import { gql } from 'graphql-request';

import type { NoteReminderQueryType } from '@/components/NoteReminder';
import type { CurrencyISO } from '@/constants/currencies';

export interface NoteFragmentType {
  id: string;
  userId: string;
  content: string;
  contentPreview: string;
  createdAt: string;
  updatedAt: string;
  noteType: {
    name: string;
  };
  noteVisibility: {
    name: string;
  };
  reminders?: Array<NoteReminderQueryType>;
  company: {
    id: string;
    listingCurrencyISO: CurrencyISO;
    canonicalURL: string;
    uniqueSymbol: string;
    analysisValue: {
      lastSharePrice: number;
    };
  };
}

export const NOTE_FRAGMENT = gql`
  fragment NoteFields on Note {
    id
    userId
    content
    contentPreview
    createdAt
    updatedAt
    noteType {
      name
    }
    noteVisibility {
      name
    }
    reminders {
      id
      status
      type
      customMessage
      deliveryDateUtc
      userTimezone
      reminderTarget {
        targetValue
        targetMetadata
      }
    }
    company {
      id
      canonicalURL
      uniqueSymbol
      listingCurrencyISO
      analysisValue {
        lastSharePrice
      }
    }
  }
`;
